import { TabView } from "@/components/layout/tab-view";
import React from "react";

export default function MainPage() {
  return (
    // <div className="flex h-screen flex-col">
    //   <div className="flex-1 overflow-auto">
    <div className="flex h-full min-h-0 min-w-0 gap-2 overflow-hidden">
      <div className="min-h-0 min-w-0 flex-1 overflow-hidden pl-1">
        <TabView />
      </div>
      {/* </div> */}
      {/* </div> */}
    </div>
  );
}
